"use client";
import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.web.js';
import { dot } from './styles.js';
import { getIsActive } from './dots.common.js';
import { useTheme } from '../utils/theming/useTheme.js';

var _excluded = ["count", "onChange", "active", "size", "activeSize", "activeColor", "inactiveColor", "progression", "vertical"];
var Dots = function Dots(_ref) {
  var count = _ref.count,
    onChange = _ref.onChange,
    _ref$active = _ref.active,
    active = _ref$active === undefined ? -1 : _ref$active,
    size = _ref.size,
    activeSize = _ref.activeSize,
    activeColor = _ref.activeColor,
    inactiveColor = _ref.inactiveColor,
    _ref$progression = _ref.progression,
    progression = _ref$progression === undefined ? 'single' : _ref$progression,
    vertical = _ref.vertical,
    props = _objectWithoutProperties(_ref, _excluded);
  var theme = useTheme();
  var dotsTheme = theme.dots.web;
  var createDots = function createDots() {
    var dots = [];
    var _loop = function _loop(id) {
      var _getIsActive = getIsActive(progression, active, id),
        _getIsActive2 = _slicedToArray(_getIsActive, 2),
        isActive = _getIsActive2[0],
        isCurrent = _getIsActive2[1];
      var element = /*#__PURE__*/React.createElement(dot, {
        key: "elemental-ui-Dot-".concat(id),
        "data-testid": "elemental-ui-Dot-".concat(id),
        "aria-hidden": "true",
        $vertical: vertical,
        $size: size || theme.dots.web.size.inactive,
        $activeSize: activeSize || theme.dots.web.size.active,
        $activeColor: activeColor ? activeColor : dotsTheme.activeColor,
        $inactiveColor: inactiveColor ? inactiveColor : dotsTheme.inactiveColor,
        onClick: function onClick() {
          // istanbul ignore next: cannot really test else case of this
          if (onChange) {
            onChange(id);
          }
        },
        $controlled: onChange ? true : false,
        $active: isActive,
        $current: isCurrent
      });
      dots.push(element);
    };
    for (var id = 0; id < count; id++) {
      _loop(id);
    }
    return dots;
  };
  return /*#__PURE__*/React.createElement(Box, _extends({
    role: "presentation",
    "data-testid": "elemental-ui-Dots",
    display: "flex",
    justifyContent: "center",
    flexDirection: vertical ? 'column' : 'row',
    alignItems: "center"
  }, props), createDots());
};

export { Dots };
